export default function replaceTemplateWithCurrentYear(
  text: string,
  template: string,
) {
  const currentYear = new Date().getFullYear().toString();

  return text.replace(template, currentYear);
}
